import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/lib/DropdownList';

import { querySelector } from '../../../utils';

/* eslint-disable */
const propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object,
  operators: PropTypes.array,

  noneOption: PropTypes.bool,
};
/* eslint-enable */

const OperatorFilter = (props) => {
  const { operators, value, onChange } = props;
  return (
    <div>
      <DropdownList
        inputProps={{
          className: 'form-control',
        }}
        filter="contains"
        allowCreate="onFilter"
        value={value}
        data={operators}
        onChange={onChange}
        valueField="id"
        textField="name"
      />
    </div>
  );
};

const GetAllOperatorsQuery = gql`
  query GetAllOperators {
    all_operators {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const operatorsResults = querySelector(data, '$.all_operators.edges[*].node', []);
  const { noneOption } = ownProps;

  let defaultOption = [{ id: null, name: 'None' }];
  if (noneOption && noneOption === true) {
    defaultOption = [];
  }

  return {
    data,
    ...ownProps,
    operators: [...defaultOption, ...operatorsResults],
  };
};

const withData = graphql(GetAllOperatorsQuery, { props: marshallData });

OperatorFilter.propTypes = propTypes;

export default withData(OperatorFilter);
